// ============================================================
// HABIT OS — Bibliothek: Hair Health
// Öle & Topika · Nährstoffe · Scalp Care · Lifestyle
// ============================================================

export const LIBRARY_HAIR = {
  id: "hair",
  label: "Hair Health",
  icon: "💇",
  subcategories: [

    // ── ÖLE & TOPIKA ─────────────────────────
    {
      id: "hair_oils",
      label: "Öle & Topika",
      icon: "🫙",
      habits: [
        {
          id: "hab_schwarzkuemmel",
          label: "Schwarzkümmelöl (intern & extern)",
          time: "morning",
          icon: "🌿",
          why: "Schwarzkümmelöl wird traditionell in der Haar- und Kopfhautpflege verwendet.",
          source: "Mohtashamipur et al., Journal of Dermatology, 2014 · Ahmad et al., Asian Pacific Journal of Tropical Biomedicine, 2013",
          dose: "Intern: laut Herstellerangabe · Extern: 2–3x pro Woche auf die Kopfhaut massieren, 30 Min. einwirken",
        },
        {
          id: "hab_rosemary_oil",
          label: "Rosmarinöl (topisch)",
          time: "flexible",
          icon: "🌿",
          why: "Rosmarinöl ist ein beliebtes ätherisches Öl in der Kopfhautpflege. Immer verdünnt in einem Trägeröl anwenden.",
          source: "Panahi et al., Skinmed, 2015 · Murata et al., Phytotherapy Research, 2013",
          dose: "3–5 Tropfen Rosmarinöl in 1 EL Trägeröl (Jojobaöl), 2–3x pro Woche auf Kopfhaut massieren, 4–8 Std. einwirken",
        },
        {
          id: "hab_castor_oil",
          label: "Rizinusöl (Castor Oil)",
          time: "night",
          icon: "🌰",
          why: "Rizinusöl ist ein dickflüssiges Pflegeöl. An Wimpern und Brauen Kontakt mit den Augen vermeiden.",
          source: "Marwah et al., International Journal of Pharmaceutics, 2007 · Vieira et al., Skin Research and Technology, 2017",
          dose: "1–2x pro Woche abends: auf Kopfhaut, Augenbrauen und Wimpern auftragen, über Nacht einwirken lassen",
        },
        {
          id: "hab_jojoba_scalp",
          label: "Jojobaöl (Kopfhautpflege)",
          time: "flexible",
          icon: "🌵",
          why: "Jojobaöl ähnelt dem hauteigenen Talg und eignet sich als leichtes Trägeröl.",
          source: "Ranzato et al., Journal of Ethnopharmacology, 2011 · Meier et al., Skin Pharmacology and Physiology, 2018",
          dose: "Als Trägeröl für andere Öle, 1–2x pro Woche als Kopfhaut-Maske für 30–60 Min.",
        },
      ],
    },

    // ── NÄHRSTOFFE FÜR HAARE ─────────────────
    {
      id: "hair_nutrition",
      label: "Nährstoffe",
      icon: "💊",
      habits: [
        {
          id: "hab_biotin",
          label: "Biotin (Vitamin B7)",
          time: "morning",
          icon: "🌟",
          why: "Biotin trägt zur Erhaltung normaler Haare und normaler Haut bei. Ein Mangel ist selten; ob er vorliegt, lässt sich nur ärztlich klären.",
          source: "Patel et al., Skin Appendage Disorders, 2017 · Zempleni et al., Nutrition Reviews, 2009",
          dose: "Laut Herstellerangabe. Biotin kann Laborwerte verfälschen, deshalb vor Blutabnahmen die Praxis informieren.",
        },
        {
          id: "hab_iron_ferritin",
          label: "Eisen (Ferritin-Optimierung)",
          time: "morning",
          icon: "🔴",
          why: "Eisen trägt zur normalen Sauerstoffversorgung bei. Ob ein Mangel besteht, lässt sich nur ärztlich per Bluttest klären.",
          source: "Trost et al., Journal of the American Academy of Dermatology, 2006 · Rushton et al., Clinical and Experimental Dermatology, 2002",
          dose: "Nur nach ärztlich festgestelltem Mangel, Dosierung laut ärztlicher Vorgabe.",
        },
        {
          id: "hab_collagen_hair",
          label: "Kollagen-Peptide für Haare",
          time: "morning",
          icon: "💪",
          why: "Kollagen-Peptide liefern Aminosäuren wie Prolin und Glycin.",
          source: "Oesser et al., Skin Pharmacology and Physiology, 2006 · Inoue et al., Journal of Agricultural and Food Chemistry, 2016",
          dose: "Laut Herstellerangabe, morgens",
        },
        {
          id: "hab_zinc_hair",
          label: "Zink für Haargesundheit",
          time: "night",
          icon: "⚙️",
          why: "Zink trägt zur Erhaltung normaler Haare bei.",
          source: "Park et al., Annals of Dermatology, 2013 · Kil et al., Annals of Dermatology, 2013",
          dose: "Laut Herstellerangabe.",
        },
      ],
    },

    // ── SCALP CARE ───────────────────────────
    {
      id: "hair_scalp",
      label: "Scalp Care",
      icon: "🧖",
      habits: [
        {
          id: "hab_scalp_massage",
          label: "Tägliche Kopfhaut-Massage",
          time: "morning",
          icon: "👐",
          why: "Eine kleine Studie (2016) fand nach 24 Wochen täglicher Kopfhaut-Massage dickere Haarschäfte. Die Massage tut außerdem gut und kann entspannend wirken.",
          source: "Koyama et al., Eplasty, 2016 · Tajik et al., Dermatology and Therapy, 2022",
          dose: "4 Min. täglich, morgens beim Duschen oder trocken — kreisende Bewegungen mit Fingerkuppen",
        },
        {
          id: "hab_scalp_exfoliation",
          label: "Kopfhaut-Peeling (wöchentlich)",
          time: "flexible",
          icon: "🧼",
          why: "Ein sanftes Peeling entfernt Schüppchen und Produktrückstände. Bei gereizter Kopfhaut darauf verzichten.",
          source: "Ranganathan & Mukhopadhyay, International Journal of Trichology, 2010",
          dose: "1x pro Woche: Salicylsäure-Serum (2%) oder Zucker-Peeling auf trockene Kopfhaut, 5 Min. einmassieren",
        },
        {
          id: "hab_cold_rinse_hair",
          label: "Kalte Schlussdusche für Haare",
          time: "morning",
          icon: "🚿",
          why: "Kaltes Wasser schließt die Schuppenschicht (Kutikula) der Haarfaser — die äußerste Schutzschicht. Warmes und heißes Wasser öffnet sie, was Feuchtigkeit entweichen lässt und Haarbruch begünstigt. Ein 30-sekündiger Kaltspülung am Ende der Dusche lässt die Kutikula flach anlegen, was das Haar glänzender, glatter und widerstandsfähiger macht.",
          source: "Bhushan et al., Journal of Cosmetic Science, 2005",
          dose: "30–60 Sekunden kaltes Wasser am Ende der Dusche, direkt auf die Haare",
        },
        {
          id: "hab_low_manipulation",
          label: "Low Manipulation Styling",
          time: "flexible",
          icon: "🎀",
          why: "Mechanischer Stress durch enge Frisuren, häufiges Bürsten, Hitzestyling und Zöpfe ist die häufigste Ursache für Traktions-Alopezie — besonders an Schläfen und Haaransatz. Jede mechanische Belastung bricht die Disulfidbrücken im Keratin und erhöht Haarbruch. Low-Heat (max. 180°C mit Hitzeschutz), lockere Bindungen und seidene Haarbänder reduzieren mechanischen Verlust signifikant.",
          source: "Miteva & Tosti, Journal of the American Academy of Dermatology, 2012",
          dose: "Max. 180°C Hitzestyling mit Hitzeschutzprodukt, nachts Seidentuch oder lockerer Zopf",
        },
      ],
    },
  ],
};